import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

interface IResponse {
    dataSources: Array<{ id: number; status: boolean }>;
}

export async function fetchDataSourcesStatus(dataSourcesIds: Array<number>) {
    const params = { data_sources: dataSourcesIds.join(',') };

    try {
        const { data } = await axios.get<IResponse>(Endpoints.User.DataSourceAccessStatus, { params });

        return data.dataSources;
    } catch (error) {
        return [];
    }
}
